import Proptypes from 'prop-types';
import kebabCase from 'lodash/kebabCase';
import React from 'react';

const OverlayFilterWrapper = ({
  filterName, filterTitle, children, ...rest
}) => (
  <div className={`${kebabCase(filterName)}-filter overlay-filter`}>
    <div className="filter-title">
      <p>{filterTitle}</p>
    </div>
    <div className={`${kebabCase(filterName)}-filter filter`}>
      {children}
    </div>
  </div>
);

OverlayFilterWrapper.propTypes = {
  filterName: Proptypes.string,
  children: Proptypes.element.isRequired,
};

OverlayFilterWrapper.defaultProps = {
  filterName: null,
};

export default OverlayFilterWrapper;
